import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Error from './Error';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ error: error, errorInfo: errorInfo });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.hasError && !prevState.hasError) {
      // Redirect to the homepage after catching an error Ensuring this runs only once by checking prevState
      // But, there is an issue in redirecting to home page. So, commenting it for now. 
      //this.props.history.push('/');
    }
  }

  render() {
    if (this.state.hasError) {
      return <Error reset={() => this.setState({hasError: false})} error={this.state.error} errorInfo={this.state.errorInfo}></Error>;
    }

    return this.props.children; 
  }
}

export default withRouter(ErrorBoundary);
